// @ts-nocheck
import { getCookie } from "@insite/client-framework/Common/Cookies";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Page from "@insite/mobius/Page";
import StretchLayout from "@store/Library/Components/Toolkit/Layout/StretchLayout";
import { getStoreListsDataView } from "@store/Framework/Store/Data/StoreLists/StoreListsSelector";
import loadStoreLists from "@store/Framework/Store/Pages/StoreLists/Handlers/LoadStoreLists";
import storeListsUpdateLoadParameter from "@store/Framework/Store/Pages/StoreLists/Handlers/UpdateLoadParameter";
import React, { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";

const mapStateToProps = (state: ApplicationState) => ({
    storeListsDataView: getStoreListsDataView(state, state.store.pages.storeLists.getStoreListsParameter),
    getStoreListsParameter: state.store.pages.storeLists.getStoreListsParameter,
});

const mapDispatchToProps = {
    storeListsUpdateLoadParameter,
    loadStoreLists,
};

type Props = ResolveThunks<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps> & PageProps;

const StoreListPage = ({
    id,
    storeListsDataView,
    getStoreListsParameter,
    loadStoreLists,
    storeListsUpdateLoadParameter,
}: Props) => {
    useEffect(() => {
        if (getStoreListsParameter.getTemporary || getStoreListsParameter.name) {
            storeListsUpdateLoadParameter({ getTemporary: false, name: "" });
        }
    }, []);

    useEffect(() => {
        const pageSizeCookie = getCookie("Lists-PageSize");
        const pageSize = pageSizeCookie ? parseInt(pageSizeCookie, 10) : undefined;
        if (pageSize && pageSize !== getStoreListsParameter.pageSize) {
            storeListsUpdateLoadParameter({ pageSize });
            return;
        }

        if (!storeListsDataView.isLoading && !storeListsDataView.value) {
            loadStoreLists();
        }
    });

    return (
        <Page>
            <StretchLayout id={id} />
        </Page>
    );
};

const pageModule: PageModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(StoreListPage),
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        fieldDefinitions: [],
        pageType: "System",
    },
};

export default pageModule;
